import { Navigate, Outlet } from "react-router-dom";
import { getEmployeeToken } from "@/lib/api";

export default function RequireEmployee() {
  const token = getEmployeeToken();
  if (!token) return <Navigate to="/employee/login" replace />;
  return <Outlet />;
}
